import {Component, EventEmitter, Input, Output} from "@angular/core";
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {EndUserSignatureOverviewDto, SignatureDto} from "../../../cross/user-signatures/type/user-signatures.types";
import {UserApiService} from "../../../cross/user/api/user-api.service";
import {AppMessageService} from "../../../core/service/app-message.service";


@Component({
  selector: 'post-activities-component',
  templateUrl: 'post-activities.component.html',
})
export class PostActivitiesComponent extends CoreComponent {

  signatureOverview: EndUserSignatureOverviewDto | undefined;
  signatures: SignatureDto[] | undefined;
  signaturesComplete: boolean = false;

  constructor(
    protected userApiService: UserApiService,
    protected messageService: AppMessageService) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
    this.initComponent();
  }

  initComponent() {
    this.retrieveSignature();
  }

  retrieveSignature() {
    this.userApiService.getSignatures().subscribe(result => {
      this.signatureOverview = result;
      this.signatures = result?.signatures;
      this.checkSignaturesComplete();
    }, error => {
      this.messageService.showErrorMessage("signature", "Es ist ein Fehler aufgetreten.");
    });
  }

  checkSignaturesComplete(): boolean {

    let signaturesComplete = true;

    if (this.signatures) {
      for (let signature of this.signatures) {
        if (!signature.signatureSwitch && !signature.signatureBase64) {
          signaturesComplete = false;
        }
      }
    }

    this.signaturesComplete = signaturesComplete;

    return signaturesComplete;

  }

  updateSignatures() {

  }

}
